<template>
  <v-container fluid grid-list-md tag="section">
    <v-card class="mx-auto">
      <v-toolbar color="white darken-4">
        <v-toolbar-title>Pagamento {{ payment.uuid }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!--v-btn icon>
            <v-icon>print</v-icon>
          </v-btn-->
      </v-toolbar>
      <v-layout row wrap>
        <v-flex d-flex xs12 order-xs5>
          <v-layout column>
            <div v-if="isLoading" class="text-xs-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <v-flex>
              <v-card flat>
                <v-card-text>
                  <p>
                    <b>Pago em: </b>
                    {{ $d(getDate(payment.created_at), "dateAndTime") }}
                  </p>
                  <p><b>Valor: </b> {{ $n(payment.amount, "currency") }}</p>
                  <p>
                    <b>Tarifas: </b> - {{ $n(payment.fees_amount, "currency") }}
                  </p>
                  <p>
                    <b>Valor a receber: </b>
                    {{ $n(amountReceivable(payment), "currency") }}
                  </p>
                  <p><b>Parcelas: </b> {{ payment.installments }}</p>
                  <p><b>Numero do P.O.S: </b> {{ payment.terminal_number }}</p>
                  <p>
                    <b>Forma de pagamento: </b>
                    {{ $t(`payment_type.${payment.credit}`) }}
                  </p>
                  <p>
                    <b>Status: </b>
                    <v-chip
                      :class="setClass(payment.status)"
                      small
                      text-color="white"
                    >
                      {{ $t(`status.${payment.status}`) }}
                    </v-chip>
                  </p>
                  <p>
                    <b>À receber em: </b>
                    {{ $d(getDate(payment.due_on), "short") }}
                  </p>
                </v-card-text>
                <!-- <v-card-actions>
                  <v-btn
                      color="indigo darken-2"
                      dark
                      @click.stop="goTo('sales')"
                    >
                    Voltar
                  </v-btn>
                </v-card-actions> -->
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
    <v-btn color="indigo darken-2" dark @click.stop="goTo('partners')">
      Voltar
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "Payment",
  created() {
    this.$store.dispatch("partners_payments/get", this.$route.params.id);
    this.$store.dispatch("partners_payments/load");
  },
  computed: {
    ...mapGetters({
      payment: "partners_payments/partnerPayment",
      isLoading: "partners_payments/loadingData",
    }),
  },
  methods: {
    ...mapActions({
      setCurrentPage: "partners_payments/setCurrentPage",
      setLimit: "partners_payments/setLimit",
    }),
    setClass(status) {
      return `payment ${status}`;
    },
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    amountReceivable(payment) {
      return payment.amount - payment.fees_amount;
    },
    paymentType: (type) => {
      if (type === true) {
        return "credit";
      }
      return "debit";
    },
    getDate(date) {
      return moment(date);
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
    /* DEBUGING METHOD */
    log(value) {
      console.log(value);
    },
  },
};
</script>
